export type PLADocumentListItem = {
   storagePath?: string;
   contentType?: string;
};

export function hasPLAElementLocalDocuments(items: PLADocumentListItem[], elementPath: string): boolean {
   const prefix = elementPath.endsWith("/") ? elementPath : `${elementPath}/`;
   return items.some((item) => item.contentType !== "directory" && typeof item.storagePath === "string" && item.storagePath.startsWith(prefix));
}
